<div class="info__box">
    <img class="info__box--icon" src="/assets/svg/icons/info.svg" alt="Ícono información">
    <h4 class="info__box--title" *ngIf="title">{{title}}</h4>
    <p class="info__box--message" *ngIf="message">{{message}}</p>
</div>